<template>
  <div class="content-wrapper">
    <Loading v-if="!loadStatus" text="Loading..." />
    <template v-if="loadStatus && !Object.keys(shopDetails).length">
      <h2 class="page-titles">E-commerce</h2>
    </template>
    <template v-if="loadStatus && Object.keys(shopDetails).length">
      <!-- {{ shopDetails }} -->
      <h2 class="page-titles">E-commerce</h2>
      <div class="row">
        <div class="column">
          <div class="header">
            <h4>Details</h4>
          </div>

          <div class="row">
            <p class="label">Enabled</p>
            <div class="content disabled">
              <label class="toggle-button">
                <input
                  type="checkbox"
                  :checked="shopDetails.status"
                  @click.prevent="toggleEnableDisable($event)"
                />
                <span class="toggle-slider round"></span>
              </label>
            </div>
          </div>

          <div class="row-logo">
            <p class="label">Logo</p>
            <div class="logo-section">
              <div class="portrait">
                <img :src="logoImage" />
              </div>
              <label for="logo-upload" class="custom-file-upload">
                Upload
              </label>
              <input id="logo-upload" type="file" @change="uploadLogo" />
            </div>
          </div>

          <div class="row-logo">
            <p class="label">Banner</p>
            <div class="banner-section">
              <div class="banner-portrait">
                <img :src="bannerImage" />
              </div>
              <label for="banner-upload" class="custom-file-upload">
                Upload
              </label>
              <input id="banner-upload" type="file" @change="uploadBanner" />
            </div>
          </div>

          <div class="row">
            <p class="label">Primary color</p>
            <div class="content">
              <div class="color-picker-container">
                <v-input-colorpicker v-model="shopDetails.primaryColor" />
              </div>
            </div>
          </div>

          <div class="row">
            <p class="label">Page title</p>
            <div class="content">
              <div class="form-group">
                <input
                  placeholder="Enter store title"
                  autocomplete="off"
                  type="text"
                  class="form-control"
                  v-model="shopDetails.title"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <p class="label">Page description</p>
            <div class="content">
              <div class="form-group">
                <textarea
                  placeholder="Tell us about the store"
                  v-model="shopDetails.description"
                />
              </div>
            </div>
          </div>

          <div class="row-buttons">
            <div class="btn-cancel">
              <router-link
                tag="button"
                :to="{ name: 'EcommerceDetails' }"
                class="whitebutton-gemnote whitebutton-gemnote--medium"
              >
                <span>Cancel</span>
              </router-link>
            </div>
            <div class="btn-save">
              <button
                class="button-gemnote button-gemnote--medium"
                :class="{ 'button-gemnote--disabled': updatingShop }"
                :disabled="updatingShop"
                @click="updateStoreInfo"
              >
                <span>Save changes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { defaultNotFoundImage, progressStatus } from '../../helpers'
import i18n from '../../internatinalization/i18n'
let bodyFormData = new FormData()

export default {
  name: 'EcommerceEdit',
  created() {
    this.$store.dispatch('ecommerce/getStoreDetails')
  },
  data() {
    return {
      noImage: defaultNotFoundImage
    }
  },
  methods: {
    uploadLogo(e) {
      if (e.target.files.length > 0) {
        let size = e.target.files[0].size
        size = Math.round(size / 1024)

        if (size >= 2048) {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [i18n.t('validations.image-size-exceeded')]
          })
          return
        }
        bodyFormData.delete('e_commerce_store[logo_file]')
        bodyFormData.append('e_commerce_store[logo_file]', e.target.files[0])
        this.shopDetails.logoImage.url = URL.createObjectURL(e.target.files[0])
      }
    },
    uploadBanner(e) {
      if (e.target.files.length > 0) {
        let size = e.target.files[0].size
        size = Math.round(size / 1024)

        if (size >= 2048) {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [i18n.t('validations.image-size-exceeded')]
          })
          return
        }

        bodyFormData.delete('e_commerce_store[banner_file]')
        bodyFormData.append('e_commerce_store[banner_file]', e.target.files[0])
        if (this.shopDetails.bannerImage !== null) {
          this.shopDetails.bannerImage = URL.createObjectURL(e.target.files[0])
        } else {
          this.shopDetails.bannerImage = {
            url: URL.createObjectURL(e.target.files[0])
          }
        }
      }
    },
    updateStoreInfo() {
      let newStoreLogo = bodyFormData.get('e_commerce_store[logo_file]')
      if (newStoreLogo === null) {
        bodyFormData.delete('e_commerce_store[logo_file]')
      }

      let newBanner = bodyFormData.get('e_commerce_store[banner_file]')
      if (newBanner === null) {
        bodyFormData.delete('e_commerce_store[banner_file]')
      }

      bodyFormData.set('e_commerce_store[title]', this.shopDetails.title)
      bodyFormData.set(
        'e_commerce_store[description]',
        this.shopDetails.description
      )
      bodyFormData.set(
        'e_commerce_store[primary_color]',
        this.shopDetails.primaryColor
      )

      this.$store.dispatch('ecommerce/editStore', bodyFormData)
    },
    toggleEnableDisable() {
      this.$store.dispatch('ecommerce/enableDisableStore')
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadShopDetails)
    },
    logoImage() {
      return this.shopDetails.logoImage
        ? this.shopDetails.logoImage.url
        : this.noImage
    },
    bannerImage() {
      return this.shopDetails.bannerImage
        ? this.shopDetails.bannerImage.url
        : this.noImage
    },
    ...mapState({
      loadShopDetails: state => state.ecommerce.loadShopDetails,
      shopDetails: state => state.ecommerce.shopDetails,
      updatingShop: state => state.ecommerce.updatingShop
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.row {
  display: flex;
  height: auto;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.row-logo {
  display: flex;
  height: auto;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.logo-section {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
}

.banner-section {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
}

input[type='file'] {
  display: none;
}

.custom-file-upload {
  display: inline-block;
  padding: 0 1rem;
  text-decoration: underline;
  cursor: pointer;
}

.row-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.btn-cancel {
  text-align: right;
  flex-basis: 45%;
}

.btn-save {
  text-align: left;
  flex-basis: 45%;
}

.column {
  flex-basis: 70%;
  padding: 2rem;
  background: $light-grey;
}

.header {
  margin-bottom: 2rem;

  h4 {
    text-align: left;
  }
}

.label {
  text-align: left;
  flex-basis: 25%;
  font-weight: 600;
}

.content {
  flex-basis: 75%;
  text-align: left;
}

.portrait {
  height: 100px;
  width: 100px;
  border: 1px solid $main-4;

  img {
    width: 100%;
    height: 100%;
    max-width: 100px;
    object-fit: cover;
    margin: 0 auto;
  }
}

.banner-portrait {
  height: 100px;
  width: 350px;
  height: 150px;
  border: 1px solid $main-4;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0 auto;
  }
}

.primary-color {
  position: absolute;
  margin-left: 5px;
  height: 18px;
  width: 18px;
  color: $onyx;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid $main-4;
  border-radius: 50%;
}

.primary-color:after {
  content: '';
  position: absolute;
  height: 22px;
  width: 22px;
  top: -4px;
  left: -4px;
  border: 1px solid $onyx;
  border-radius: 50%;
}

.form-group input {
  padding: 0 1rem !important;
}

.form-group textarea {
  padding: 0.5rem 1rem;
  border-radius: 0px;
  border: 1px solid $onyx;
  background: $light-grey;
  height: 8rem;
  resize: none;
}

@media screen and (max-width: 1100px) and (min-width: 930px) {
  .column {
    flex-basis: 75%;
  }
}

@media screen and (max-width: 929px) and (min-width: 750px) {
  .column {
    flex-basis: 85%;
  }
}

@media screen and (max-width: 749px) and (min-width: 650px) {
  .column {
    flex-basis: 95%;
  }
}

@media screen and (max-width: 649px) and (min-width: 550px) {
  .column {
    flex-basis: 100%;
  }

  .label {
    flex-basis: 35%;
  }

  .content {
    flex-basis: 65%;
  }
}

@media screen and (max-width: 549px) and (min-width: 350px) {
  .column {
    flex-basis: 100%;
  }

  .row {
    flex-direction: column;
    align-items: normal;
    margin-bottom: 2.5rem;
  }

  .row-logo {
    flex-direction: column;
    align-items: normal;
  }

  .label {
    flex-basis: 100%;
  }

  .content {
    flex-basis: 100%;
  }
}
</style>
